// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RewardListingSkeletonWrapper {
  position: relative;
}
.RewardListingSkeletonWrapper .headSection {
  max-width: 1200px;
  width: 100%;
  padding: 0 20px;
  margin: 0 auto;
}
.RewardListingSkeletonWrapper .headSection .head {
  border-radius: 20px;
  width: 100%;
  margin: 24px 0;
}
@media (max-width: 768px) {
  .RewardListingSkeletonWrapper .headSection .head {
    margin: 16px 0;
  }
}
.RewardListingSkeletonWrapper .bannerSkeleton {
  margin: 0 auto;
  margin-bottom: 16px;
  max-width: 1200px;
  width: 100%;
  padding: 0 20px;
}
.RewardListingSkeletonWrapper .nameInfo {
  max-width: 1200px;
  width: 100%;
  padding: 0 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 28px auto;
}
.RewardListingSkeletonWrapper .cardInfo {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  gap: 16px;
  overflow-x: auto;
  padding-bottom: 16px;
}
.RewardListingSkeletonWrapper .cardInfo .infoSkeleton {
  border-radius: 10px;
  min-width: 280px;
}
@media (max-width: 768px) {
  .RewardListingSkeletonWrapper .cardInfo .infoSkeleton {
    min-width: 150px;
  }
}
.RewardListingSkeletonWrapper .cardInfo .UICard {
  border-radius: 10px;
}
.RewardListingSkeletonWrapper .tabSection {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;
}
@media (max-width: 768px) {
  .RewardListingSkeletonWrapper .tabSection {
    padding: 0 16px;
  }
}
.RewardListingSkeletonWrapper .filterSection {
  max-width: 1200px;
  width: 100%;
  margin: 40px auto 0;
  padding: 0 20px;
  display: flex;
  gap: 16px;
}
@media (max-width: 768px) {
  .RewardListingSkeletonWrapper .filterSection {
    margin: 0 auto;
    gap: 0;
  }
}
.RewardListingSkeletonWrapper .filterSection .rightSection {
  width: 100%;
}
.RewardListingSkeletonWrapper .filterSection .rightSection .tabSkeleton {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 8px;
  align-items: flex-end;
  justify-content: flex-start;
}
@media (max-width: 768px) {
  .RewardListingSkeletonWrapper .filterSection .rightSection .tabSkeleton {
    justify-content: center;
    align-items: center;
    display: none;
  }
}
.RewardListingSkeletonWrapper .filterSection .rightSection .tabSkeleton .skeletonOne {
  width: 120px;
}
@media (max-width: 768px) {
  .RewardListingSkeletonWrapper .filterSection .rightSection .tabSkeleton .skeletonOne {
    width: 100px;
  }
}
.RewardListingSkeletonWrapper .filterSection .rightSection .cardSection {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 30px;
}
@media (max-width: 768px) {
  .RewardListingSkeletonWrapper .filterSection .rightSection .cardSection {
    gap: 20px;
    justify-content: space-between;
    margin-top: 20px;
  }
}
.RewardListingSkeletonWrapper .filterSection .rightSection .cardSection .card {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px;
}
.RewardListingSkeletonWrapper .filterSection .rightSection .cardSection .card .icon {
  border-radius: 6px;
}
.RewardListingSkeletonWrapper .bottomBanner {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;
  height: 260px;
  margin: 40px 0;
}
.RewardListingSkeletonWrapper .bottomBanner .banner {
  display: block;
  border-radius: 20px;
}
@media (max-width: 768px) {
  .RewardListingSkeletonWrapper .bottomBanner {
    height: 150px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Partials/SkeletonUI/RewardListingSkeleton/RewardListingSkeleton.scss","webpack://./src/Styles/_mixins.scss"],"names":[],"mappings":"AACA;EACE,kBAAA;AAAF;AAEE;EACE,iBAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AAAJ;AAEI;EACE,mBAAA;EACA,WAAA;EACA,cAAA;AAAN;ACDE;EDFE;IAMI,cAAA;EACN;AACF;AAGE;EACE,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;AADJ;AAIE;EACE,iBAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;AAFJ;AAKE;EACE,iBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,SAAA;EACA,gBAAA;EACA,oBAAA;AAHJ;AAKI;EACE,mBAAA;EACA,gBAAA;AAHN;ACpCE;EDqCE;IAKI,gBAAA;EAFN;AACF;AAKI;EACE,mBAAA;AAHN;AAOE;EACE,iBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;AALJ;AClDE;EDmDA;IAOI,eAAA;EAJJ;AACF;AAOE;EACE,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,SAAA;AALJ;AC/DE;ED8DA;IASI,cAAA;IACA,MAAA;EAJJ;AACF;AAMI;EACE,WAAA;AAJN;AAMM;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;EACA,qBAAA;EACA,2BAAA;AAJR;AChFE;ED8EI;IASI,uBAAA;IACA,mBAAA;IACA,aAAA;EAHR;AACF;AAKQ;EACE,YAAA;AAHV;AC1FE;ED4FM;IAII,YAAA;EAFV;AACF;AAMM;EACE,aAAA;EACA,eAAA;EACA,2BAAA;EACA,SAAA;AAJR;ACrGE;EDqGI;IAOI,SAAA;IACA,8BAAA;IACA,gBAAA;EAHR;AACF;AAKQ;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;AAHV;AAIU;EACE,kBAAA;AAFZ;AASE;EACE,iBAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;AAPJ;AASI;EACE,cAAA;EACA,mBAAA;AAPN;ACpIE;EDiIA;IAcI,aAAA;EAPJ;AACF","sourcesContent":["@import \"src/Styles/theme.scss\";\n.RewardListingSkeletonWrapper {\n  position: relative;\n\n  .headSection {\n    max-width: 1200px;\n    width: 100%;\n    padding: 0 20px;\n    margin: 0 auto;\n\n    .head {\n      border-radius: 20px;\n      width: 100%;\n      margin: 24px 0;\n\n      @include respond-md {\n        margin: 16px 0;\n      }\n    }\n\n  }\n  .bannerSkeleton {\n    margin: 0 auto;\n    margin-bottom: 16px;\n    max-width: 1200px;\n    width: 100%;\n    padding: 0 20px;\n  }\n\n  .nameInfo {\n    max-width: 1200px;\n    width: 100%;\n    padding: 0 20px;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin: 28px auto;\n  }\n\n  .cardInfo {\n    max-width: 1200px;\n    width: 100%;\n    margin: 0 auto;\n    padding: 0 20px;\n    display: flex;\n    gap: 16px;\n    overflow-x: auto;\n    padding-bottom: 16px;\n\n    .infoSkeleton {\n      border-radius: 10px;\n      min-width: 280px;\n\n      @include respond-md {\n        min-width: 150px;\n      }\n    }\n\n    .UICard {\n      border-radius: 10px;\n    }\n  }\n\n  .tabSection {\n    max-width: 1200px;\n    width: 100%;\n    margin: 0 auto;\n    padding: 0 20px;\n\n    @include respond-md {\n      padding: 0 16px;\n    }\n  }\n\n  .filterSection {\n    max-width: 1200px;\n    width: 100%;\n    margin: 40px auto 0;\n    padding: 0 20px;\n    display: flex;\n    gap: 16px;\n\n    @include respond-md {\n      margin: 0 auto;\n      gap: 0;\n    }\n\n    .rightSection {\n      width: 100%;\n\n      .tabSkeleton {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 16px;\n        margin-bottom: 8px;\n        align-items: flex-end;\n        justify-content: flex-start;\n\n        @include respond-md {\n          justify-content: center;\n          align-items: center;\n          display: none;\n        }\n\n        .skeletonOne {\n          width: 120px;\n\n          @include respond-md {\n            width: 100px;\n          }\n        }\n      }\n\n      .cardSection {\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: flex-start;\n        gap: 30px;\n\n        @include respond-md {\n          gap: 20px;\n          justify-content: space-between;\n          margin-top: 20px;\n        }\n\n        .card {\n          display: flex;\n          flex-direction: column;\n          justify-content: flex-start;\n          align-items: flex-start;\n          border: 1px solid $color-gray-200;\n          border-radius: 10px;\n          padding: 10px;\n          .icon {\n            border-radius: 6px;\n          }\n        }\n      }\n    }\n  }\n\n  .bottomBanner {\n    max-width: 1200px;\n    width: 100%;\n    margin: 0 auto;\n    padding: 0 20px;\n    height: 260px;\n    margin: 40px 0;\n\n    .banner {\n      display: block;\n      border-radius: 20px;\n    }\n\n    @include respond-md {\n      height: 150px;\n    }\n  }\n}","@import './breakpoints';\n\n// ====================================\n// 📱 Media Query Mixins\n// ====================================\n@mixin respond-sm {\n  @media (max-width: $breakpoint-sm) {\n    @content;\n  }\n}\n\n@mixin respond-md {\n  @media (max-width: $breakpoint-md) {\n    @content;\n  }\n}\n\n@mixin respond-lg {\n  @media (max-width: $breakpoint-lg) {\n    @content;\n  }\n}\n\n@mixin respond-xlg {\n  @media (max-width: $breakpoint-xlg) {\n    @content;\n  }\n}\n\n@mixin respond-xxlg {\n  @media (max-width: $breakpoint-xxlg) {\n    @content;\n  }\n}\n\n@mixin respond-xxxlg {\n  @media (max-width: $breakpoint-xxxlg) {\n    @content;\n  }\n}\n\n@mixin respond-max {\n  @media (max-width: $breakpoint-max) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
